export default __webpack_public_path__ + "static/scraping-0190e892c9e579fdd672293073548960.jpeg";